import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { requirePersonsMaySignUp } from '../auth/sign-up-policy.ts'
import { entryRoute } from './entry.tsx'
import { NAV_PATHS } from '../navigation/paths.ts'

// The parent's own account, one step past the fork. Shut while persons may not sign up, it
// answers as a path that does not exist (docs/adr/0013-la-prima-release-registra-solo-le-societa.md).
export const signUpParentRoute = createRoute({
  getParentRoute: () => entryRoute,
  path: NAV_PATHS.signUpParent,
  beforeLoad: requirePersonsMaySignUp,
  component: lazyRouteComponent(() => import('../pages/sign-up-parent.tsx')),
})
